import { Grid, GridItem } from '@chakra-ui/react';
import { IUsageTypeResSchema } from '@monetize/types/app';
import { MFormField, MText } from '..';
import { ROUTES } from '../../../constants';
import { USAGE_TYPE_EDIT_ROLES } from '../../../constants/roles';
import { USAGE_TYPE_STATUS_DISPLAY } from '../../../constants/usageTypes';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface UsageTypeLookupPopoverProps {
  value: string;
}

export function UsageTypeLookupPopover({ value }: UsageTypeLookupPopoverProps) {
  if (!value) {
    return null;
  }
  return (
    <RecordLookupPopover
      recordId={value}
      endpoint={`/api/usageTypes/${value}`}
      renderRecord={(record) => {
        const usageType = record as IUsageTypeResSchema;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={usageType.id}
              href={ROUTES.getUsageTypeEditRoute(usageType.id)}
              recordName={usageType.name}
              displayStatus={USAGE_TYPE_STATUS_DISPLAY[usageType.status]}
              roles={USAGE_TYPE_EDIT_ROLES}
            />

            <Grid gridTemplateColumns="1fr 1fr" rowGap={4} mt={4}>
              <GridItem>
                <MFormField label="Plural Name">
                  <MText>{usageType.pluralName}</MText>
                </MFormField>
              </GridItem>
              {usageType.description && (
                <GridItem colSpan={2}>
                  <MFormField label="Description">
                    <MText lineClamp={3}>{usageType.description}</MText>
                  </MFormField>
                </GridItem>
              )}
              <MFormField label="Unit Name">
                <MText>{usageType.unitName}</MText>
              </MFormField>
              <MFormField label="Decimal Places">
                <MText>{usageType.decimalPlaces}</MText>
              </MFormField>
            </Grid>
          </>
        );
      }}
    >
      {value}
    </RecordLookupPopover>
  );
}
